/**
 * Local Storage
 */

export enum EStorageField {
  COST_FORMULA = 'costFormula',
  EVALUATION_UNIT = 'evaluationUnit',
  FORECAST = 'forecast',
  NAME = 'name',
  PAY_CYCLE = 'payCycle',
  PAY_DELAY = 'payDelay',
  PARETO_DEALS = 'paretoDeals',
  PARETO_DEAL_IDS = 'paretoDealIds',
  PRODUCT_LINE = 'productLine',
  REGION = 'region',
  STANDARD_PAY_CYCLE = 'stdPayCycle',
  STANDARD_PAY_DELAY = 'stdPayDelay',
  VOLUME_UNIT = 'volumeUnit',
  PARETO_HAS_VOLUME_WIDTH_BARS = 'paretoHasVolumeWidthBars',
  PORTFOLIO_DEAL_IDS = 'portfolioDealIds',
  PORTFOLIO_DEALS = 'portfolioDeals',
  UPDATE_IDS = 'updateIds',
  UPDATE_CONTENT = 'updateContent',
}

export enum EModalTitle {
  PARETO = 'Pareto',
  PORTFOLIO = 'Portfolio',
}

export enum EUpdateModalTitle {
  NEW_UPDATE = 'New Update',
  EDIT_UPDATE = 'Edit Update',
}

export enum EUpdateModalSubTitle {
  NEW_UPDATE = 'Enter update title and description below.',
  EDIT_UPDATE = 'Edit update title and description below.',
}

export enum EUpdateModalButton {
  NEW_UPDATE = 'Post Update',
  EDIT_UPDATE = 'Done',
}

export function getCachedValue(field: EStorageField, defaultValue?: string) {
  return localStorage.getItem(field) ?? defaultValue ?? '';
}
